export default __webpack_public_path__ + "static/media/shape1.362d8738.png";